// extracted by mini-css-extract-plugin
export default {"container":"styles_container__SLi1a","row":"styles_row__QC8E8"};